import React from "react";
//import Modal from "react-responsive-modal";
import ReactModal from "react-modal";
import { branch } from "baobab-react/higher-order";
import autoBind from "react-autobind";
import _ from "lodash"; import Baobab from "baobab";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import * as actions from "../actions/actions";
import { getJwtToken } from "../actions/user";
import env from "../constants/env";
import PlayerPaths from "../constants/paths/playerPaths";
import webPlayerState from "../state/webPlayerState";
import ambifiWebPlayerConfig from "../constants/webPlayerConfig/ambifi";
import state from "../state/state";
import PlayerZoid from "../components/player/playerZoid";
import AppConstants from "../constants/appConstants";

import PreviewWrapper from "./shared/previewWrapper";

class ChecklistPreviewModal extends React.PureComponent {

	constructor(props) {
		super(props);
		autoBind(this);
		this.webPlayerRef = React.createRef();
		this.previewLoadSignature = this.getPreviewLoadSignature(props);
		this.state = {
			fallbackToTop: false
		};
		this.initWebPlayerState(props);
	}

	UNSAFE_componentWillReceiveProps(nextProps) {
		this.resetPreviewLoadFallback(nextProps);
		if (this.props.previewChecklist.showModal === false && nextProps.previewChecklist.showModal) {
			this.initWebPlayerState(nextProps);
		}
	}

	getPreviewLoadSignature(props = this.props) {
		const checklistId = _.get(props, "previewChecklist.checklist.id", "");
		const session = _.get(props, "previewChecklist.session", "");
		const showModal = _.get(props, "previewChecklist.showModal", false);
		return `${checklistId}:${session}:${showModal}`;
	}

	resetPreviewLoadFallback(nextProps = this.props) {
		const nextSignature = this.getPreviewLoadSignature(nextProps);
		if (nextSignature !== this.previewLoadSignature) {
			this.previewLoadSignature = nextSignature;
			if (this.state.fallbackToTop) {
				this.setState({ fallbackToTop: false });
			}
		}
	}

	getEffectiveChecklist() {
		const checklist = _.get(this.props, "previewChecklist.checklist", null);
		if (!_.isObject(checklist) || this.state.fallbackToTop !== true) {
			return checklist;
		}

		const fallbackChecklist = _.cloneDeep(checklist);
		delete fallbackChecklist.selected;
		delete fallbackChecklist.selectedListIndex;
		return fallbackChecklist;
	}

	handleOnLoadError(err) {
		console.error("Unable to load modal preview player", err);
		actions.hideDocumentsSpinner();

		if (this.state.fallbackToTop !== true) {
			this.setState({ fallbackToTop: true });
		}
	}

	handleExit() {
		this.props.dispatch(actions.closePreviewModal);
	}

	initWebPlayerState(props) {
		let newWebPlayerState = new Baobab(_.cloneDeep(webPlayerState.get()));
		// newWebPlayerState.set(["player", "readOnly"], true);
		newWebPlayerState.set(["user"], props.user);
		newWebPlayerState.set(["_config"], { showControls: false, showHeaderPanel: true, startInShowMode: true, listViewMode: "list" });
		newWebPlayerState.set(["appPreferences", "checkbarLocation"], "hidden");
		newWebPlayerState.set(["timerTemplates"], _.cloneDeep(state.get(["timerTemplates"])));

		this.newWebPlayerState = newWebPlayerState.get();
	}

	render() {
		if (!this.props.previewChecklist || (this.props.previewChecklist && !this.props.previewChecklist.checklist.hasOwnProperty("id"))) {
			return null;
		}

			let closeButton =
				<div style={{ display: "flex", flexDirection: "column", alignItems: "flex-end", position: "absolute", right: "10px", top: "12px", width: "32px" }}>
					<div className="custom-player-modal-close-button">
						<FontAwesomeIcon icon="times" onClick={() => this.props.dispatch(actions.closePreviewModal)} />
					</div>
				</div>;
		// let modalTitle = "Preview";
		console.log(this.props.previewChecklist.checklist);
		console.log(this.props.selectedActivityId);
		const effectiveChecklist = this.getEffectiveChecklist();
		let orgPreferences = {};
		if (this.props.selectedOrg) {
			const { preferences } = this.props.selectedOrg;
			orgPreferences = _.pick(preferences, ["tts-phonetics", "theme", "stylesheet", "fonts", "playlists"]); // Limit this for now to prevent very large props
		}
		const addtlProps = {};
		if (this.props.previewChecklist && _.isNumber(this.props.previewChecklist.session)) {
			addtlProps.key = `cache-key-${this.props.previewChecklist.session}-${this.state.fallbackToTop ? "top" : "selected"}`;
		}
		let credentials = "";
		if (window.awsTempCredentials) {
			credentials = btoa(JSON.stringify({
				iid: _.get(this.props, "user.identityId", ""),
				sak: window.awsTempCredentials.secretAccessKey,
				ak: window.awsTempCredentials.accessKeyId,
				st: window.awsTempCredentials.sessionToken
			}));
		}
		const previewPlayerConfig = {
			...ambifiWebPlayerConfig,
			debugVarsInspector: true,
			persistence: {
				...(ambifiWebPlayerConfig.persistence || {}),
				useInjectedActivities: true,
				previewUploads: {
					enabled: true,
					rootFolder: "previewAssets",
					activityId: _.get(this.props, "previewChecklist.checklist.id", "preview"),
					sessionId: _.isNumber(_.get(this.props, "previewChecklist.session")) ? String(this.props.previewChecklist.session) : "preview",
					skipBackgroundProcessing: true
				}
			}
		};

		let activity = effectiveChecklist ? <div style={{ flex: 1 }} className="ambifi-web-player-container status"><PlayerZoid
			activities={[effectiveChecklist]}
			activityId={effectiveChecklist.id}
			config={previewPlayerConfig}
			env={_.cloneDeep(env)}
			drive={{ guidToResource: this.props?.drive?.guidToResource || {} }}
			state={this.newWebPlayerState}
			credentials={credentials}
			jwt={getJwtToken()}
			componentRequester={"ambifiCloud"}
			onExit={this.handleExit}
			onLoad={() => actions.hideDocumentsSpinner()}
			onLoadError={this.handleOnLoadError}
			debugVarsInspector={true}
			orgPreferences={orgPreferences}
			ref={this.webPlayerRef}
			{...addtlProps} /></div> : <div><FontAwesomeIcon
				name='spinner'
				spin /> Loading activity for preview, please wait...</div>;




		const component = <ReactModal style={{ overlay: { zIndex: AppConstants.react.components.reactModal.zIndex, backgroundColor: "#666666" } }} className="custom-player-modal" isOpen={this.props.previewChecklist.showModal} little>
			{/* <h3 style={{ textAlign: "center" }}>{modalTitle}</h3> */}
			<div style={{ display: "flex", height: "100vh", overflow: "auto", flexDirection: "column" }}>
				<PreviewWrapper compact={true}>
					{activity}
				</PreviewWrapper>
			</div>
			{closeButton}
		</ReactModal>;

		return component;
	}
}

export default branch({
	user: ["user"],
	drive: ["appState", "previewChecklist", "drive"],
	player: PlayerPaths.ROOT,
	selectedActivityId: PlayerPaths.SELECTED_ACTIVITY_ID,
	appCapabilities: ["appCapabilities"],
	selectedOrg: ["selectedOrg"],
	previewChecklist: ["appState", "previewChecklist"]
}, ChecklistPreviewModal);
